export enum IMessageEvents {
  SHOW_HEADER = 'SHOW_HEADER',
  HIDE_HEADER = 'HIDE_HEADER',
  SHOW_OVERLAY = 'SHOW_OVERLAY',
  HIDE_OVERLAY = 'HIDE_OVERLAY',
  SET_1024_WIDTH = 'SET_1024_WIDTH'
}
